import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isImpersonating, getImpersonatedUser, adminAPI } from '@/lib/adminApi';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Eye, X } from 'lucide-react';

export default function ImpersonationBanner() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const impersonatedUser = getImpersonatedUser();
  
  if (!isImpersonating() || !impersonatedUser) {
    return null;
  }

  const handleStopImpersonation = async () => {
    await adminAPI.endImpersonation();
    await refreshUser();
    navigate('/admin');
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-[#C6A14A] text-[#050816]">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Eye className="h-4 w-4" />
          <span className="font-medium text-sm">
            Admin Support Mode: viewing as {impersonatedUser.email}
          </span>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={handleStopImpersonation}
          className="text-[#050816] hover:bg-[#050816]/10 h-7 px-2"
        >
          <X className="h-4 w-4 mr-1" />
          Stop
        </Button>
      </div>
    </div>
  );
}
